import React from "react";
import styles from "./SingleOpinion.module.scss";
import { withStyles } from "@material-ui/core/styles";
import Rating from "@material-ui/lab/Rating";
import StarRoundedIcon from "@material-ui/icons/StarRounded";
import StarBorderRoundedIcon from "@material-ui/icons/StarBorderRounded";
import tmpAvatar from "src/assets/img/avatar.png";
import * as moment from "moment";
class SingleOpinion extends React.Component<any, any> {
  render() {
    const { opinion } = this.props;

    if (!opinion.isVerified || !opinion.description) {
      return null;
    }

    return (
      <div className={styles.SingleOpinion} key={opinion.id}>
        <div className={styles.header}>
          <img src={tmpAvatar} alt="client avatar" className={styles.avatar} />
          <div className={styles.details}>
            <div className={styles.name}>
              {opinion.client.name} {opinion.client.surname}
            </div>

            {opinion.client.companyName && (
              <div className={styles.company}>{opinion.client.companyName}</div>
            )}

            <div className={styles.appointmentDetails}>
              {moment(opinion.date).format("D MMMM YYYY")} •{" "}
              {opinion.appointment && (
                <>
                  <strong>konsultacja online</strong> •{" "}
                </>
              )}
              {opinion.domain.name}
            </div>
          </div>
        </div>
        <div className={styles.description}>{opinion.description}</div>

        <Rating
          name="star-rating"
          value={opinion.rate}
          precision={0.5}
          className={styles.stars}
          readOnly
          size="small"
          icon={<StarRoundedIcon />}
          emptyIcon={<StarBorderRoundedIcon />}
        />
      </div>
    );
  }
}

SingleOpinion.defaultProps = {};

export default SingleOpinion;
